import React, { useEffect, useState } from "react";
import MyResults from "./MyResults";
import TakeTest from "./TakeTest";
import Loader from "./Loader";
import Layout from "./Layout";
import MyClasses from "./MyClasses";
import MyClassDetails from "./MyClassDetails";
import TranscriptionPage from "./TranscriptionPage";
import { LanguageProvider } from "./LanguageContext";
import ResultPage from "./Resultpage";
import TestPage from "./TestPage";

const Dashboard = () => {
  const [isLoading, setIsLoading] = useState(true);
  const path = window.location.pathname.split("/")[1];

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  const renderSection = (activeSection) => {
    switch (activeSection) {
      case "my-results":
        return <MyResults />;
      case "take-test":
        return <TakeTest />;
      case "my-class":
        return <MyClasses />;
      case "class":
        return <MyClassDetails />;
      case "result":
        return <ResultPage />;
      case "transcription":
        return <TranscriptionPage />;
      case "attempt":
        return <TestPage />;
      default:
        return <MyClasses />;
    }
  };

  return !isLoading ? (
      <LanguageProvider>
        <Layout>{renderSection(path)}</Layout>
      </LanguageProvider>
  ) : (
      <Loader />
  );
};

export default Dashboard;